/** "Open to co-founder introductions": a card used on the student and freelancer profiles. */
import { api } from '../../core/api.js';
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { reload } from '../../app/shell.js';

import { field, tagField } from '../../ui/forms.js';
import { submitForm } from '../../ui/submit.js';
import { toast } from '../../ui/toast.js';

export const loadCofounder = (signal) => api.get('/me/cofounder', { signal }).then((d) => d.cofounder);

export function cofounderCard(cf) {
  const v = cf || { bio: '', skills: [], mode: '', open_to_intro: false };
  return html`<div class="card"><h3>Open to co-founder introductions</h3>
    <p class="mu sm">Startup founders cannot message you directly. If you switch this on, Vignova may introduce you to a founder whose idea fits, and you choose whether to accept.</p>
    <form data-submit="cofounder.save" novalidate>
      <label class="row sm" style="gap:8px;margin-bottom:10px"><input type="checkbox" name="open_to_intro" ${v.open_to_intro ? 'checked' : ''}> <span>Yes, I am open to introductions</span></label>
      ${field('cf-bio', 'About you', { name: 'bio', rows: 3, req: false, max: 300, val: v.bio, help: 'Up to 300 characters.' })}
      ${tagField('cf-skills', 'Skills you would bring', { name: 'skills', preset: v.skills, help: 'Optional.', req: false })}
      ${field('cf-mode', 'How would you like to work together?', { name: 'mode', req: false, maxlength: 80, val: v.mode, ph: 'Part-time to start, equity based' })}
      <button class="btn" type="submit">Save</button></form></div>`;
}

register({
  'cofounder.save': (form) => submitForm(form, async (values) => {
    await api.put('/me/cofounder', { body: { open_to_intro: Boolean(values.open_to_intro), bio: values.bio, skills: values.skills, mode: values.mode } });
    toast('Saved');
    await reload();
  }),
});

